import { render } from "./versionpopup.vue?vue&type=template&id=3feec5f0&scoped=true"
import script from "./versionpopup.js?vue&type=script&lang=js"
export * from "./versionpopup.js?vue&type=script&lang=js"

import "./versionpopup.vue?vue&type=style&index=0&id=3feec5f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feec5f0"]])

export default __exports__